
<template>
  <div class="download-app">
    <a :href="downloadPath">下载优学APP</a>
  </div>
</template>

<script>
import { ExternalInterfaceUtil } from "@/utils";

export default {
  computed: {
    downloadPath() {
      return this.mobileType === ExternalInterfaceUtil.TYPE.IPHONE
        ? process.env.VUE_APP_IPHONE_DOWNLOAD_URL
        : process.env.VUE_APP_ANDROID_DOWNLOAD_URL;
    }
  }
};
</script>
<style scoped>
.download-app {
  background: #ffffff;
  color: #74b3fa;
  border: 1px solid rgba(231, 232, 233, 1);
  border-radius: 8px 0px 0px 0px;
}
.download-app  a{
  display: block;
  color: #74b3fa;
}
</style>